import { createAsyncThunk } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

import { APP } from 'src/Configs/App'
import { NameSpace } from 'src/Redux/types'

interface CheckUserEmailToSignInResponse {
  type: string
}

export const checkUserEmailToSignIn = createAsyncThunk<
  CheckUserEmailToSignInResponse,
  string
>(
  `${NameSpace.AuthType}/checkUserEmailToSignIn`,
  async (email, { rejectWithValue }) => {
    try {
      const { data } = await axios.get<CheckUserEmailToSignInResponse>(
        `${APP.SERVER}/auth/check/${email}`,
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        code: response?.status,
      })
    }
  },
)
